import type {EmbedProps} from '@interfaces/Embed';
import {getEmbed} from '@utils/embedFactory';
import type {ReactElement} from 'react';
import {Suspense} from 'react';
import type {EmbedType} from '@constants/embedType';

interface Props {
    type: EmbedType;
    params: EmbedProps;
}

export default function Embed(props: Props): ReactElement<Props> {
    const Component = getEmbed(props.type);

    return (
        <Suspense /*fallback={<Loading {...props.Design} />}*/>
            <Component {...props.params} />
        </Suspense>
    );
}
